var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeThCol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#68688a",
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 607.978 808.485 C 607.978 907.019 714.644 968.603 799.978 919.336 C 839.581 896.471 863.978 854.215 863.978 808.485 L 863.978 211.151 C 863.978 112.617 757.311 51.033 671.978 100.3 C 632.374 123.165 607.978 165.421 607.978 211.151 L 607.978 808.485 Z M 522.644 808.485 L 522.644 211.151 C 522.644 46.927 700.422 -55.713 842.644 26.399 C 908.65 64.508 949.311 134.935 949.311 211.151 L 949.311 808.485 C 949.311 972.709 771.533 1075.349 629.311 993.237 C 563.305 955.128 522.644 884.701 522.644 808.485 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 601.307 1341.054 L 601.307 743.72 C 601.307 579.496 779.085 476.856 921.307 558.968 C 987.313 597.077 1027.974 667.504 1027.974 743.72 L 1027.974 1341.054 C 1027.974 1505.278 850.196 1607.918 707.974 1525.806 C 641.968 1487.697 601.307 1417.27 601.307 1341.054 Z",
    transform: "matrix(1, 0, 0, 1, -521.582458, -530.466125)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeThCol);
export default __webpack_public_path__ + "static/media/change_th_col.0b29c7d7f295fcf24c584b871cef4cb2.svg";
export { ForwardRef as ReactComponent };